import {
    GETTRANSACTIONLISTREFUND_SUCCESS,
    GETTRANSACTIONLISTREFUND_FAILED,
    RESET_GETTRANSACTIONLISTREFUND,
    LOADING_GETTRANSACTIONLISTREFUND,
    NETWORK_ERROR_GETTRANSACTIONLISTREFUND,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetTransactionListRefund = () => {
    return { type: RESET_GETTRANSACTIONLISTREFUND };
};

const getTransactionListsRefund =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETTRANSACTIONLISTREFUND });
        await partnerServices
            .post("getTransactionList", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getTransactionListRefundSuccess(res.data));
                        break;
                    default:
                        dispatch(getTransactionListRefundFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETTRANSACTIONLISTREFUND,
                    payload: err,
                });
            });
    };
function getTransactionListRefundSuccess(data) {
    return {
        type: GETTRANSACTIONLISTREFUND_SUCCESS,
        payload: data,
    };
}
function getTransactionListRefundFailed(data) {
    return {
        type: GETTRANSACTIONLISTREFUND_FAILED,
        payload: data,
    };
}

export { resetGetTransactionListRefund, getTransactionListsRefund };
